import React, { useEffect, useState } from 'react'
import { Text, View, TextInput, TouchableOpacity } from 'react-native'
import { FormFieldsModel, ModelAnswerFromProps } from '../models/StoreDetailModel'
import styles from './InputNumberPriceFieldStyles'
import { schedulesServices } from '../../../../database/schedules.database'
import { updateFormAnswerSchedule } from '../../../../db-sqlite/repositories/schedule.repository'
import theme from '../../../../theme'
import { getLanguage } from '../../appBar/context/LocalizationContext'

interface InputNumberPriceFieldProps {
    item: FormFieldsModel
    form_id: string
    schedule_id: string
    store_id: string
    answerProp: ModelAnswerFromProps
    closeBottomSheet: (l) => void
    checkComplete: (option?: ModelAnswerFromProps) => void
    keyboardHiddenState: boolean
    onFocus: (id: string) => void
    activeInputId: string
    isPrice: boolean
}

export const InputNumberPriceField = ({
    item,
    form_id,
    schedule_id,
    store_id,
    answerProp,
    closeBottomSheet,
    checkComplete,
    keyboardHiddenState,
    onFocus,
    activeInputId,
    isPrice,
}: InputNumberPriceFieldProps) => {
    //console.log('🚀 ~ answerProp:', answerProp)
    // console.log('🚀 ~ item:', item)
    const { languageFile } = getLanguage()

    const [text, setText] = useState('')
    //console.log('🚀 ~ text:', text)

    useEffect(() => {
        //  console.log('21: InputNumberPriceField - answerProp: ', answerProp)

        if (answerProp.field_text && answerProp.field_text != '') {
            // console.log('22-------- tengo respuesta old: ', answerProp)

            setText(answerProp.field_text || '')
        } else {
            //    console.log('26-------- no tengo respuesta old InputNumberPriceField')
        }
    }, [item])
    useEffect(() => {
        if (keyboardHiddenState && activeInputId == item._id) {
            if (text !== '') {
                validateAnswer(text)
            }
        }
    }, [keyboardHiddenState])

    const validateAnswer = (text) => {
        if (text.trim() != '') {
            console.log('Entre')
            create_answer(text)
        }
    }
    const create_answer = (inputText: string) => {
        const answer: ModelAnswerFromProps = {
            _id: answerProp._id,
            option_selected_text: answerProp.option_selected_text,
            option_selected_id: answerProp.option_selected_id,
            question_id: answerProp.question_id,
            media: '',
            question_text: answerProp.question_text,
            score: answerProp.score ? answerProp.score.toString() : '0',
            status: 1,
            date_finish: new Date().toString(),
            date_init: new Date().toString(),
            question_input: '',
            field_media: '',
            field_text: inputText,
            questionScore: answerProp.questionScore,
            index: answerProp.index,
            type: answerProp.type,
            ponderar: answerProp.questionScore && answerProp.questionScore > 0, //[7, 8, 14, 18].includes(answerProp.type),

            question: answerProp?.question_text,
            questionOptionSelected: answerProp?.option_selected_id,
            questionOptionSelectedText: answerProp?.option_selected_text,
            questionType: answerProp.questionType,
            questionPrice: inputText,
            tag: '',
            questionImage: '',
            questionInput: inputText,

            sku: answerProp.sku,
            description: answerProp.description ?? '',
            description_short: answerProp.description_short ?? '',
        }

        updateFormAnswerSchedule({
            newAnswer: answer,
            schedule_id,
            form_id,
            store_id,
        })
        checkComplete(answer)
    }

    return (
        <View style={styles.container}>
            <View style={styles.containerInput}>
                {item.label && <Text style={styles.label}>{item.label}</Text>}
                <View style={styles.containerInputPrice}>
                    {isPrice === true && <Text style={styles.text}>$</Text>}
                    <TextInput
                        style={styles.inputPrice}
                        autoFocus={false}
                        placeholder='----'
                        placeholderTextColor={theme.colors.inputPlaceholder}
                        value={text}
                        onChangeText={(text) => setText(text)}
                        keyboardType='number-pad'
                        inputMode='decimal'
                        onEndEditing={(e) => validateAnswer(e.nativeEvent.text)}
                        onSubmitEditing={(e) => validateAnswer(e.nativeEvent.text)}
                        onFocus={() => onFocus(item._id)}
                    />
                </View>
            </View>

            {/* <View style={styles.buttonContainer}>
                <TouchableOpacity style={styles.borderButton} onPress={validateAnswer}>
                    <Text style={styles.borderButtonText}>{languageFile.confirm}</Text>
                </TouchableOpacity>
            </View> */}
        </View>
    )
}
